export default {

    state: {
      procurador: null,
      msgProcurador: null
    },
  
    mutations: {
        setProcurador(state, payload) {
          state.procurador = payload;
        },
        setMsgProcurador(state, payload) {
          state.msgProcurador = payload;
        }
    },
  
    getters: {
      getProcurador(state) {
        return state.procurador;
      },
      getMsgProcurador(state) {
        return state.msgProcurador
      }
    },

    actions: {
        setProcurador({commit}, procurador){
          commit('setProcurador', procurador);
        },
        setMsgProcurador({ commit }, msgProcurador) {
          commit('setMsgProcurador', msgProcurador)
        }
    },
    
  }